import styled from 'styled-components'

interface IFileViewerPreviewStyledProps {}

export const FileViewerPreviewStyled = styled.div<IFileViewerPreviewStyledProps>`
  height: 100%;
  width: 100%;
`
